var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "userAdd app-container" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "用户管理", url: "/system/userManage" },
                { label: "用户信息", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _vm.editUser
        ? _c(
            "div",
            { staticClass: "form-top" },
            [
              _c("p", { staticClass: "form-top-title" }, [
                _vm._v("用户基本信息")
              ]),
              _c("el-divider"),
              _c(
                "div",
                { staticClass: "form-top-bot" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: {
                        model: _vm.formInline,
                        "label-position": "top",
                        "validate-on-rule-change": false,
                        rules: _vm.rules
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-top-bot-item" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "用户编号", prop: "userId" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.editBtn,
                                  placeholder: "请输入用户编号"
                                },
                                model: {
                                  value: _vm.formInline.userId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formInline, "userId", $$v)
                                  },
                                  expression: "formInline.userId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "用户名称", prop: "userName" }
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入用户名称" },
                                model: {
                                  value: _vm.formInline.userName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formInline, "userName", $$v)
                                  },
                                  expression: "formInline.userName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "职级", prop: "mngLevel" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "limit32",
                                  attrs: {
                                    clearable: "",
                                    size: "small",
                                    placeholder: "请选择职级信息"
                                  },
                                  model: {
                                    value: _vm.formInline.mngLevel,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formInline, "mngLevel", $$v)
                                    },
                                    expression: "formInline.mngLevel"
                                  }
                                },
                                _vm._l(_vm.mngList, function(item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      value: item.key,
                                      label: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "职位", prop: "jobCodeList" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    multiple: "",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    placeholder: "请输入职位关键词",
                                    "remote-method": _vm.getManageLevel,
                                    "collapse-tags":
                                      _vm.formInline.jobCodeList.length > 1,
                                    size: "small",
                                    loading: _vm.manageLoading
                                  },
                                  model: {
                                    value: _vm.formInline.jobCodeList,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formInline,
                                        "jobCodeList",
                                        $$v
                                      )
                                    },
                                    expression: "formInline.jobCodeList"
                                  }
                                },
                                _vm._l(_vm.manageList, function(item) {
                                  return _c("el-option", {
                                    key: item.jobCode,
                                    attrs: {
                                      label: item.jobName,
                                      value: item.jobCode
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-last",
                              attrs: { label: "邮箱地址", prop: "mail" }
                            },
                            [
                              _c("el-input", {
                                staticClass: "limit32",
                                attrs: {
                                  size: "small",
                                  maxlength: "32",
                                  "show-word-limit": "",
                                  placeholder: "请输入用户编号"
                                },
                                model: {
                                  value: _vm.formInline.mail,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formInline,
                                      "mail",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formInline.mail"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "form-top-bot-item" },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "联系方式", prop: "telephone" }
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  onkeyup:
                                    "this.value = this.value.replace(/[^\\d.]/g,'');",
                                  maxlength: "16",
                                  "show-word-limit": "",
                                  placeholder: "请输入联系方式",
                                  size: "small"
                                },
                                model: {
                                  value: _vm.formInline.telephone,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formInline,
                                      "telephone",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formInline.telephone"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "所属部门", prop: "orgId" }
                            },
                            [
                              _c("org-select", {
                                attrs: {
                                  modal: false,
                                  multiple: false,
                                  placeholder: "请选择所属部门"
                                },
                                model: {
                                  value: _vm.formInline.orgId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formInline, "orgId", $$v)
                                  },
                                  expression: "formInline.orgId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "所属条线", prop: "busLinCode" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "limit32",
                                  attrs: {
                                    size: "small",
                                    placeholder: "请选择条线信息"
                                  },
                                  model: {
                                    value: _vm.formInline.busLinCode,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formInline,
                                        "busLinCode",
                                        $$v
                                      )
                                    },
                                    expression: "formInline.busLinCode"
                                  }
                                },
                                _vm._l(_vm.buslinList, function(item) {
                                  return _c("el-option", {
                                    key: item.key,
                                    attrs: {
                                      value: item.key,
                                      label: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-contant",
                              attrs: { label: "用户状态", prop: "userStatus" }
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择用户状态",
                                    size: "small"
                                  },
                                  model: {
                                    value: _vm.formInline.userStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formInline,
                                        "userStatus",
                                        $$v
                                      )
                                    },
                                    expression: "formInline.userStatus"
                                  }
                                },
                                _vm._l(_vm.state, function(item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      value: item.key,
                                      label: item.value
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-top-bot-item-last",
                              attrs: { label: "", prop: "btn" }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "btn-red addUserSureBtn",
                                  staticStyle: {
                                    "margin-top": "26px",
                                    border: "none"
                                  },
                                  on: { click: _vm.saveUserInfo }
                                },
                                [
                                  _c("i", { staticClass: "save-icon" }),
                                  _vm._v("保存用户信息")
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "form-showInfo",
              staticStyle: { position: "relative" }
            },
            [
              _c("p", { staticClass: "form-showInfo-title" }, [
                _vm._v("用户基本信息")
              ]),
              _c("el-divider"),
              _c("div", { staticClass: "form-showInfo-bot" }, [
                _c(
                  "div",
                  {
                    staticClass: "form-showInfo-bot-top",
                    staticStyle: { display: "flex", "align-items": "center" }
                  },
                  _vm._l(_vm.showUserInfoList1, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "form-showInfo-bot-item",
                        staticStyle: { width: "25%" }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "form-showInfo-bot-item-label",
                            style: { minWidth: item.value.length + 1 + "em" }
                          },
                          [_vm._v(_vm._s(item.value) + "：")]
                        ),
                        item.key == "mngLevel"
                          ? _c(
                              "p",
                              { staticClass: "form-showInfo-bot-item-content" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.dict_info["MANAGER_LEVEL"][
                                      _vm.formInline[item.key]
                                    ]
                                  )
                                )
                              ]
                            )
                          : _c(
                              "p",
                              {
                                staticClass: "form-showInfo-bot-item-content",
                                attrs: {
                                  title:
                                    item.key == "jobCodeList"
                                      ? _vm.getLevelInfo(_vm.formInline.jobList)
                                      : _vm.formInline[item.key]
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.key == "jobCodeList"
                                      ? _vm.getLevelInfo(_vm.formInline.jobList)
                                      : _vm.formInline[item.key]
                                  )
                                )
                              ]
                            )
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  {
                    staticClass: "form-showInfo-bot-btm",
                    staticStyle: { display: "flex", "align-items": "center" }
                  },
                  [
                    _vm._l(_vm.showUserInfoList2, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "form-showInfo-bot-item",
                          staticStyle: { width: "25%" }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "form-showInfo-bot-item-label",
                              style: { minWidth: item.value.length + 1 + "em" }
                            },
                            [_vm._v(_vm._s(item.value) + "：")]
                          ),
                          item.key == "busLinCode"
                            ? _c(
                                "p",
                                {
                                  staticClass: "form-showInfo-bot-item-content"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.dict_info["BUSINESS_LINE"][
                                        _vm.formInline[item.key]
                                      ]
                                    )
                                  )
                                ]
                              )
                            : _c(
                                "p",
                                {
                                  staticClass: "form-showInfo-bot-item-content"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      item.key == "userStatus"
                                        ? _vm.getState(_vm.formInline[item.key])
                                        : _vm.formInline[item.key]
                                    )
                                  )
                                ]
                              )
                        ]
                      )
                    }),
                    _c(
                      "div",
                      { staticStyle: { width: "25%" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.editUserInfo }
                          },
                          [
                            _c("editIcon", {
                              staticStyle: {
                                "vertical-align": "middle",
                                "margin-right": "8px"
                              }
                            }),
                            _vm._v("编辑用户信息")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ])
            ],
            1
          ),
      _c(
        "div",
        {
          staticClass: "form-bot",
          class: { opt: _vm.isAdd && !_vm.saveSuccess }
        },
        [
          _vm.isAdd && !_vm.saveSuccess
            ? _c("div", { staticClass: "form-bot-mask" })
            : _vm._e(),
          _c("p", { staticClass: "form-top-title" }, [_vm._v("配置角色信息")]),
          _c("el-divider"),
          _c(
            "div",
            { staticClass: "form-bot-search" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline",
                  staticStyle: { display: "flex", "align-items": "flex-end" },
                  attrs: {
                    inline: true,
                    model: _vm.searchList,
                    "label-position": "top"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "224px", "margin-right": "120px" },
                      attrs: { label: "系统名称" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "224px" },
                          attrs: {
                            placeholder: "请选择系统名称",
                            size: "small",
                            clearable: ""
                          },
                          model: {
                            value: _vm.searchList.systemId,
                            callback: function($$v) {
                              _vm.$set(_vm.searchList, "systemId", $$v)
                            },
                            expression: "searchList.systemId"
                          }
                        },
                        _vm._l(_vm.systemList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { width: "224px", "margin-right": "64px" },
                      attrs: { label: "角色名称" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入角色名称", clearable: "" },
                        model: {
                          value: _vm.searchList.roleName,
                          callback: function($$v) {
                            _vm.$set(_vm.searchList, "roleName", $$v)
                          },
                          expression: "searchList.roleName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("input", {
                        staticClass: "btn btn-red search-btn",
                        staticStyle: { "margin-right": "20px", height: "32px" },
                        attrs: { type: "button", value: "查询" },
                        on: { click: _vm.search }
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-right": "20px" },
                          on: { click: _vm.resetSearch }
                        },
                        [
                          _c("reset", {
                            staticClass: "reset-icon",
                            staticStyle: { "vertical-align": "bottom" }
                          }),
                          _vm._v(" 重置 ")
                        ],
                        1
                      ),
                      _c("input", {
                        staticClass: "btn btn-red add-btn",
                        staticStyle: { "margin-right": "20px", height: "32px" },
                        attrs: { type: "button", value: "新增角色" },
                        on: { click: _vm.pushRole }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.showLoading,
                  expression: "showLoading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                "element-loading-customClass": "loadingSize",
                "element-loading-background": "rgba(0, 0, 0, 0.2)",
                data: _vm.tableData,
                border: "",
                "highlight-current-row": "",
                height: _vm.tableheight,
                "tooltip-effect": "dark",
                "tree-props": { children: "data" },
                lazy: "",
                "row-key": "viewId",
                indent: 10
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: { fixed: "", resizable: false, width: "50" }
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "systemName",
                    "min-width": "50",
                    "show-overflow-tooltip": ""
                  }
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("系统名称")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "roleName",
                    "min-width": "80",
                    "show-overflow-tooltip": ""
                  }
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色名称")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "viewOrgs",
                    "min-width": "80",
                    "show-overflow-tooltip": ""
                  }
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("管辖部门")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "viewLines",
                    "min-width": "80",
                    "show-overflow-tooltip": ""
                  }
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("管辖条线")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: {
                    prop: "autoList",
                    "show-overflow-tooltip": "",
                    "min-width": "80"
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return !!scope.row.roleId
                            ? [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: { effect: "dark", placement: "top" }
                                  },
                                  [
                                    _c("div", {
                                      attrs: { slot: "content" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.ToBreak(
                                            scope.row.resourceType.value
                                          )
                                        )
                                      },
                                      slot: "content"
                                    }),
                                    _c("div", { staticClass: "line" }, [
                                      _vm._v(
                                        _vm._s(scope.row.resourceType.value)
                                      )
                                    ])
                                  ]
                                )
                              ]
                            : undefined
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色用户关系来源")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { prop: "roleDesc", "min-width": "80" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("div", {
                                attrs: { slot: "content" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.ToBreak(scope.row.roleDesc || "")
                                  )
                                },
                                slot: "content"
                              }),
                              _c("div", { staticClass: "line" }, [
                                _vm._v(_vm._s(scope.row.roleDesc || ""))
                              ])
                            ]
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("span", { staticClass: "header-ellipsis font14" }, [
                      _vm._v("角色说明")
                    ])
                  ])
                ],
                2
              ),
              _vm.isEdit
                ? _c("el-table-column", {
                    attrs: { label: "操作", fixed: "right", width: "55" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return !!scope.row.roleId &&
                              (scope.row.edit || scope.row.del)
                              ? [
                                  _c(
                                    "el-popover",
                                    {
                                      ref: "role-" + scope.row.id,
                                      attrs: {
                                        placement: "right",
                                        width: "200",
                                        trigger: "click",
                                        "popper-class": "table-popper"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "op-tips" },
                                        [
                                          scope.row.edit
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "op-item ",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.edit(scope.row)
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("operate-edit-icon", {
                                                    staticClass:
                                                      "svgOperateIcon"
                                                  }),
                                                  _vm._v(" 编辑角色和信息")
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-popconfirm",
                                            {
                                              attrs: {
                                                title: "确定删除该角色？"
                                              },
                                              on: {
                                                onConfirm: function($event) {
                                                  return _vm.delUserRole(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              scope.row.del
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "op-item ",
                                                      attrs: {
                                                        slot: "reference"
                                                      },
                                                      slot: "reference"
                                                    },
                                                    [
                                                      _c("delIcon", {
                                                        staticClass:
                                                          "svgOperateIcon"
                                                      }),
                                                      _vm._v(" 删除")
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      scope.row.resourceType.key ===
                                      "MANUALLY_ADD"
                                        ? _c("operate", {
                                            staticClass: "operate-icon",
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn ",
          attrs: {
            width: "544px",
            title: _vm.isAddRole ? "新增角色配置" : "编辑角色配置",
            visible: _vm.showRoleConfig
          },
          on: {
            "update:visible": function($event) {
              _vm.showRoleConfig = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "dialog-body" },
            [
              _c(
                "el-form",
                {
                  ref: "userConfig",
                  staticClass: "dialog-content",
                  attrs: {
                    "label-position": "top",
                    model: _vm.userConfig,
                    rules: _vm.userConfigRules,
                    "label-width": "120px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-content-item",
                      attrs: { label: "用户名称", prop: "userName" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          disabled: "",
                          placeholder: "请输入用户名称"
                        },
                        model: {
                          value: _vm.userConfig.userName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userConfig,
                              "userName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "userConfig.userName"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-content-item",
                      attrs: { label: "用户编号", prop: "userId" }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "small",
                          disabled: "",
                          placeholder: "请输入用户编号"
                        },
                        model: {
                          value: _vm.userConfig.userId,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.userConfig,
                              "userId",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "userConfig.userId"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-content-item",
                      attrs: { label: "系统名称", prop: "systemId" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            "reserve-keyword": "",
                            disabled: !_vm.isAddRole,
                            placeholder: "请选择系统名称",
                            size: "small"
                          },
                          on: { change: _vm.changeSystemId },
                          model: {
                            value: _vm.userConfig.systemId,
                            callback: function($$v) {
                              _vm.$set(_vm.userConfig, "systemId", $$v)
                            },
                            expression: "userConfig.systemId"
                          }
                        },
                        _vm._l(_vm.systemList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-content-item",
                      attrs: { label: "角色名称", prop: "roleInfo" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            disabled: !_vm.isAddRole,
                            "value-key": "roleId",
                            size: "small",
                            placeholder: "请选择角色名称"
                          },
                          on: { change: _vm.getRoleId },
                          model: {
                            value: _vm.userConfig.roleInfo,
                            callback: function($$v) {
                              _vm.$set(_vm.userConfig, "roleInfo", $$v)
                            },
                            expression: "userConfig.roleInfo"
                          }
                        },
                        _vm._l(_vm.roleList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item, label: item.roleName }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.userConfig.canSetManageLine
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "dialog-content-item",
                          attrs: { label: "管辖部门", prop: "manageOrgList" }
                        },
                        [
                          _c("org-select", {
                            attrs: {
                              multiple: true,
                              modal: false,
                              placeholder: "请选择拟稿部门"
                            },
                            model: {
                              value: _vm.userConfig.manageOrgList,
                              callback: function($$v) {
                                _vm.$set(_vm.userConfig, "manageOrgList", $$v)
                              },
                              expression: "userConfig.manageOrgList"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.userConfig.canSetbusinessLine
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "dialog-content-item",
                          attrs: { label: "管辖条线", prop: "bizLineList" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "limit32",
                              attrs: {
                                size: "small",
                                multiple: "",
                                "collapse-tags": "",
                                placeholder: "请选择条线信息"
                              },
                              model: {
                                value: _vm.userConfig.bizLineList,
                                callback: function($$v) {
                                  _vm.$set(_vm.userConfig, "bizLineList", $$v)
                                },
                                expression: "userConfig.bizLineList"
                              }
                            },
                            _vm._l(_vm.buslinList, function(item) {
                              return _c("el-option", {
                                key: item.key,
                                attrs: { value: item.key, label: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-content-item",
                      attrs: { label: "AB角", prop: "corner" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            size: "small",
                            placeholder: "请选择角色类型"
                          },
                          model: {
                            value: _vm.userConfig.corner,
                            callback: function($$v) {
                              _vm.$set(_vm.userConfig, "corner", $$v)
                            },
                            expression: "userConfig.corner"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "A角", value: "A" }
                          }),
                          _c("el-option", {
                            attrs: { label: "B角", value: "B" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "margin-top": "0px" }
            },
            [
              _c("el-button", { on: { click: _vm.subCancel } }, [
                _vm._v("取消")
              ]),
              _c(
                "el-button",
                {
                  staticClass: "btn btn-red addUserSureBtn",
                  staticStyle: { height: "32px", border: "none" },
                  on: {
                    click: function($event) {
                      return _vm.submitUserForm()
                    }
                  }
                },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }